import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '@environment';

declare let ga: any;

@Injectable({
    providedIn: 'root',
})
export class GoogleAnalyticsService {
    constructor(private router: Router) {}

    initGoogleAnalytics(googleAnalyticsId) {
        /* eslint-disable */
        ((i, s, o, g, r, a, m) => {
            i['GoogleAnalyticsObject'] = r;
            (i[r] =
                i[r] ||
                function () {
                    (i[r].q = i[r].q || []).push(arguments);
                }),
                (i[r].l = +new Date());
            (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
        /* eslint-enable */

        let domainName;
        if (window.location.hostname === 'localhost') {
            domainName = '';
        } else {
            domainName = 'socialboards.com';
        }

        ga('create', environment.gaGlobalTrackerId, {
            cookieDomain: domainName,
            cookiePath: this.router.url.split('?')[0],
        });

        // send analytics about first visited page
        ga('set', 'page', this.router.url);
        ga('send', 'pageview', this.router.url);

        if (googleAnalyticsId) {
            ga('create', googleAnalyticsId, 'auto', { name: 'FormUser' });
            ga('FormUser.send', 'pageview');
        }

        // subscribe to router events and send page views to Google Analytics
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                ga('set', 'page', event.urlAfterRedirects);
                ga('send', 'pageview', this.router.url);
            }
        });
    }

    initGoogleTagManager(googleTagManagerId) {
        /* Google Tag Manager (script) */
        /* eslint-disable */
        ((w, d, s, l, i) => {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js',
            });
            const f = d.getElementsByTagName(s)[0];
            const j = d.createElement(s);
            const dl = l != 'dataLayer' ? '&l=' + l : '';
            (j as any).async = true;
            (j as any).src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', googleTagManagerId);
        /* eslint-enable */

        /* Google Tag Manager (noscript) */
        const noscript = document.createElement('noscript');
        const iframe = document.createElement('iframe');
        const iframeSource = 'https://www.googletagmanager.com/ns.html?id=' + googleTagManagerId;
        iframe.setAttribute('src', iframeSource);
        iframe.setAttribute('style', 'display:none; visibility:hidden');
        iframe.setAttribute('height', '0');
        iframe.setAttribute('width', '0');
        noscript.appendChild(iframe);
        document.body.appendChild(noscript);
    }
}
